// @flow
import React from "react";
import "./PlayerPlaceholder.scss";

export default function PlayerPlaceholder(props: { label: string }) {
  return (
    <span className="gazelle-preview__player-placeholder">
      {props.label}
    </span>
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/gazelle/PlayerPlaceholder.js